<button mat-icon-button mat-dialog-close class="close">
  <mat-icon aria-label="Close shopping cart">close</mat-icon>
</button>

<mat-dialog-content>
  <p class="mt-3 text-center">
    <ng-container
      *ngIf="!data.status"
      i18n="Generic error message when creating booking|Failed order dialog when the user is trying to place
      order"
      >We are really sorry, there seems to be an error in the system. Please try again later.</ng-container
    >

    <ng-container *ngIf="data.tourInvalidOptions?.length">
      <ng-container i18n="Not enough seats message|Failed order dialog when the user is trying to place order"
        >We are really sorry, there are not enough seats for</ng-container
      >
      {{ data.tourInvalidOptions.join(", ") }}
      <ng-container i18n="Not enough seats message part 3|Failed order dialog when the user is trying to place order"
        >for the chosen date and time. Please try another one.</ng-container
      >
    </ng-container>

    <ng-container
      *ngIf="data.hotelInvalidOptions?.length"
      i18n="Not enough rooms message|Failed order dialog when the user is trying to place order"
      >We are really sorry, this room has just been booked. Please chose another one.</ng-container
    >
    <ng-container
      *ngIf="data.eventInvalidOptions?.length"
      i18n="Not enough seats message for event|Failed order dialog when the user is trying to place order"
      >We are really sorry, there are not enough tickets.</ng-container
    >

    <ng-container *ngIf="paymentFailed" i18n="Payment failed|Failed order dialog when the user is trying to place order"
      >We are really sorry, the payment failed. Please try again later.</ng-container
    >
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-auto">
        <button mat-button class="dialog-close" cdkFocusInitial (click)="dialogRef.close()">
          <ng-container
            *ngIf="noAvailability"
            i18n="Caption of “Change booking date” button|Failed order dialog when the user is trying to place order"
            >Change booking date</ng-container
          >
          <ng-container
            *ngIf="paymentFailed || !data.status"
            i18n="Caption of “Try again later” button|Failed order dialog when the user is trying to place order"
            >Try again later</ng-container
          >
        </button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
